import { Component } from '@angular/core';
import { Title } from '../../node_modules/@angular/platform-browser';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  template: '<router-outlet></router-outlet>'
})
export class AppComponent {
  constructor(private titleService: Title) {
    this.titleService.setTitle(environment.app_title);
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts